import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ServicingBaseComponent } from '@common/components';
import { MY_BOOKING_TAB_IDENTIFIER, PREVIOUS_PAGE_IDENTIFIER } from '@common/interfaces/servicing-common';
import { ServicingCommonStoreService } from '@common/services/servicing-common-store/servicing-common-store.service';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-pet-easy-travel-request-sub-header',
  templateUrl: './pet-easy-travel-request-sub-header.component.html',
  styleUrls: ['./pet-easy-travel-request-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PetEasyTravelRequestSubHeaderComponent extends ServicingBaseComponent {
  // 戻るボタン遷移先：予約詳細画面(S01-P030)
  backUrl: string = SERVICING_ROUTES.myBooking;

  constructor(
    private _commonLibService: CommonLibService,
    private _router: Router,
    private _servicingCommonStoreService: ServicingCommonStoreService
  ) {
    super(_commonLibService);
  }

  override init(): void {}
  override reload(): void {}
  override destroy(): void {}

  back(): void {
    // 予約詳細表示タブ=”service”(予約詳細(サービス))を保持
    this._servicingCommonStoreService.updateServicingCommon({
      tabShow: MY_BOOKING_TAB_IDENTIFIER.SERVICE,
      previousPageIdentifier: PREVIOUS_PAGE_IDENTIFIER.PET_EASY_TRAVEL_REQUEST,
    });
  }
}
